module.exports = __webpack_public_path__ + "efe5e9c0050ce2c17fe3b571144dbec7.woff2";